var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z",
    fill: "#333D6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9773 22.8613L37.7864 20.0522C37.7864 20.0522 37.7864 20.0522 37.7932 20.0454C38.1273 19.7113 38.1273 19.1727 37.7932 18.8386C37.4591 18.5045 36.9205 18.5045 36.5864 18.8386C36.5864 18.8386 36.5864 18.8386 36.5796 18.8454L33.7705 21.6545L33.6068 21.8181H19.1387C18.3887 21.8181 17.775 22.4318 17.775 23.1818V36.7499C17.775 37.009 17.85 37.2477 17.9728 37.4522L15.5455 39.8795C15.5455 39.8795 15.5387 39.8795 15.5387 39.8863C15.2046 40.2204 15.2046 40.759 15.5387 41.0931C15.8727 41.4272 16.4114 41.4272 16.7455 41.0931C16.7455 41.0931 16.7455 41.0863 16.7523 41.0863L34.1318 23.7068L34.9773 22.8613Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2955 23.584L37.275 26.809V23.1818C37.275 23.1068 37.2682 23.0386 37.2546 22.9704L34.9773 25.2477L34.1318 26.0931L22.1114 38.1136H35.9114C36.6614 38.1136 37.275 37.4999 37.275 36.7499V33.0545L43.2955 36.2795C43.7523 36.5249 44.2977 36.1909 44.2977 35.6795V29.9318V24.184C44.2977 23.6727 43.7455 23.3386 43.2955 23.584Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.4c52b23c42590ebddff6ce3276016eb5.svg";
export { ForwardRef as ReactComponent };